import { render, staticRenderFns } from "./PurchaseOrderStatusRegular.vue?vue&type=template&id=b710b224&scoped=true&"
import script from "./PurchaseOrderStatusRegular.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderStatusRegular.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderStatusRegular.vue?vue&type=style&index=0&id=b710b224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b710b224",
  null
  
)

export default component.exports